import React, { useMemo, useRef, useState, useEffect } from 'react';
import { CLUBS } from '../../../services/utils/clubs';
const MAX_SUGGESTIONS = 8;
/**
 * Suggestions only appear once the user has typed something, and are capped
 * to a short, scrollable list - native <input list="..."> datalists leave this
 * up to the browser, and on mobile Chrome that means showing all ~1300 clubs
 * full-screen the moment the field is focused.
 */
const ClubAutocomplete = ({ value, onChange, onCommit, inputClassName, placeholder, autoFocus }) => {
    const [open, setOpen] = useState(false);
    const wrapperRef = useRef(null);
    const matches = useMemo(() => {
        const query = value.trim().toLowerCase();
        if (!query)
            return [];
        return CLUBS.filter(c => c.name.toLowerCase().includes(query)).slice(0, MAX_SUGGESTIONS);
    }, [value]);
    useEffect(() => {
        if (!open)
            return;
        const handler = (e) => {
            if (wrapperRef.current && !wrapperRef.current.contains(e.target)) {
                setOpen(false);
            }
        };
        document.addEventListener('mousedown', handler);
        return () => document.removeEventListener('mousedown', handler);
    }, [open]);
    const handleSelect = (name) => {
        onChange(name);
        setOpen(false);
        onCommit?.(name);
    };
    return (React.createElement("div", { className: "club-autocomplete", ref: wrapperRef },
        React.createElement("input", { type: "text", className: inputClassName, value: value, onChange: e => { onChange(e.target.value); setOpen(true); }, onFocus: () => { if (value.trim())
                setOpen(true); }, onBlur: () => { setOpen(false); onCommit?.(value); }, placeholder: placeholder, autoFocus: autoFocus, autoComplete: "off" }),
        open && matches.length > 0 && (React.createElement("ul", { className: "club-autocomplete-list", role: "listbox", onMouseDown: e => e.preventDefault() }, matches.map(club => (React.createElement("li", { key: club.code },
            React.createElement("button", { type: "button", className: "club-autocomplete-option", onClick: () => handleSelect(club.name) }, club.name))))))));
};
export default ClubAutocomplete;
